import { CT } from "@/lib/connectionsTheme";

export const INTAKE_MODEL_STATUS_LABELS = {
  draft: "Draft",
  active: "Active",
  inactive: "Inactive",
};

export const INTAKE_MODEL_STATUS_STYLES = {
  draft: `${CT.badge} ${CT.badgeMuted}`,
  active: `${CT.badge} ${CT.badgeActive}`,
  inactive: `${CT.badge} ${CT.badgeAmber}`,
};

export const INTAKE_PURPOSE_OPTIONS = ["Service Request", "Estimate Request", "Consultation Request", "General Inquiry", "Custom"];

export const INTAKE_DEFAULT_STATUS_OPTIONS = [
  { value: "new", label: "New" },
  { value: "in_review", label: "In Review" },
  { value: "awaiting_customer", label: "Awaiting Customer" },
];

export const btn = CT.btnPrimary;
export const outlineBtn = CT.btnSecondary;
export const card = `${CT.panel} p-5`;
export const labelClass = CT.label;
export const inputClass = CT.input;
